import { render, staticRenderFns } from "./ArAging.vue?vue&type=template&id=2633eb17&scoped=true"
import script from "./ArAging.vue?vue&type=script&lang=js"
export * from "./ArAging.vue?vue&type=script&lang=js"
import style0 from "./ArAging.vue?vue&type=style&index=0&id=2633eb17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633eb17",
  null
  
)

export default component.exports